/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  Button,
  Divider,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  // TablePagination,
  TableRow,
  TextField,
} from "@mui/material";
import FormTitle from "../../../form-fields/form-title";
import SelectInput from "../../../form-fields/select-input";
import DateInput from "../../../form-fields/date-picker";
import DashBoardContainer from "../../../layout/dashboard-container";
import {
  FormLabel,
  FormValue,
  GridRow,
} from "../generate-receipt/custom-form-grid";
import { useSelector } from "react-redux";
import { labels } from "../../../../lang/labels";
import { useFormik, FormikProvider, Form } from "formik";
import { potkirdBillReceiptSchema } from "../../../../utils/validation-schema";
import "./portkirdStyle.css";
import { useReactToPrint } from "react-to-print";
import { Print } from "@mui/icons-material";
import FormButtons from "../buttons";
import { getModeOfPayments } from "../../../../services/generate-counter-receipt";
import { getUserZoneList } from "../../../../services/coinage-challan-service";
import { getBillReceiptPotkirdReport } from "../../../../services/potkird-report-service";
import useApiState from "../../common/useApiState";
import Loader from "../../../loader/loader";
import AlertMsg from "../../../common/alert";
import ScrollTop from "../../../common/scrollTop";
import { getCurrentDate } from "../../../../utils/helpers";
import {
  showToastError,
  showToastSuccess,
  showToastWarn,
} from "../../../common/toastHelper";
import ScrollBottom from "../../../common/scrollBottom";

const PotkirdReportForBillReceipt = () => {
  const initialState = {
    fromDate: getCurrentDate(),
    toDate: getCurrentDate(),
    zoneKey: "",
    counterName: "",
    modeOfPayment: "",
  };
  const printRef = useRef();

  const lang = useSelector((state) => state.userDetails.lang);

  const formik = useFormik({
    initialValues: initialState,
    validationSchema: potkirdBillReceiptSchema,
    onSubmit: (values) => {
      alert(JSON.stringify(values, null, 2));
    },
  });

  const [zoneList, setzoneList] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [counterLists, setCounterLists] = useState([
    { value: "Counter1", label: "Counter 1" },
    { value: "Counter2", label: "Counter 2" },
  ]);
  const [modeOfPaymentList, setmodeOfPaymentList] = useState([]);
  const [billReceiptData, setBillReceiptData] = useState({
    potkirdResponseVOlst: [],
  });
  const [searchTerm, setSearchTerm] = useState("");
  const { loading, setLoading, error, setError } = useApiState();

  // const [page, setPage] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState(10);

  // // Handle page change
  // const handleChangePage = (event, newPage) => {
  //   setPage(newPage);
  // };

  // Handle rows per page change
  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(parseInt(event.target.value, 10));
  //   setPage(0);
  // };
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        setError("");
        setLoading(true);
        const [modeOfPaymentsData, zoneList] = await Promise.all([
          getModeOfPayments(),
          getUserZoneList(),
        ]);
        setmodeOfPaymentList(modeOfPaymentsData);
        const formattedList = zoneList.map((item) => {
          return {
            value: item.zonekey,
            label: item.zonename,
          };
        });
        setzoneList(formattedList);
        // showToastSuccess();
      } catch (error) {
        showToastError("Failed to retrive Zone or Mode of payment details!!");
      } finally {
        setLoading(false);
      }
    };
    const shouldFetchData = !zoneList.length && !modeOfPaymentList.length;

    if (shouldFetchData) {
      fetchData();
    }
  }, [zoneList, modeOfPaymentList]);

  const handleSubmit = async () => {
    try {
      setError("");
      setLoading(true);
      setBillReceiptData({
        potkirdResponseVOlst: [],
      });
      const modeOfPaymentName = modeOfPaymentList.find(
        (item) => item.id === formik.values.modeOfPayment
      );
      let reqBody = {
        ...formik.values,
        zoneName: "",
        modeOfPayment: modeOfPaymentName.name || "",
        zoneKey: formik.values.zoneKey.toString(),
      };
      const res = await getBillReceiptPotkirdReport(reqBody);
      // console.log(res);
      setBillReceiptData(res);
      if (res.potkirdResponseVOlst.length === 0) {
        showToastWarn("No records found");
      } else {
        showToastSuccess();
      }
    } catch (error) {
      showToastError("Failed to get Bill Receipt Potkird Report");
    } finally {
      setLoading(false);
    }
  };

  // Handle search input change
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  // Filter rows based on search term
  const filteredRows = billReceiptData.potkirdResponseVOlst.filter(
    (row) =>
      row.propertyCode.toLowerCase().includes(searchTerm.toLowerCase()) ||
      row.receiptNo.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const zone =
    zoneList.find((item) => item.value === formik.values.zoneKey) || "-";
  const selectdeModeOfPayment =
    modeOfPaymentList.find((item) => item.id === formik.values.modeOfPayment) ||
    "-";

  const tableCellCss = {
    fontSize: "12px",
    padding: "5px",
    letterSpacing: 0,
    lineHeight: 1.5,
  };
  return (
    <DashBoardContainer>
      <ScrollBottom />
      <Grid>
        <FormikProvider value={formik}>
          <Form>
            {loading && <Loader />}
            {error && (
              <AlertMsg
                message={error}
                severity="error"
                onClose={() => {
                  setError("");
                }}
              />
            )}
            <Paper elevation={4} sx={{ marginBottom: "15px" }}>
              <FormTitle title={labels.PotkirdForBillReceipt[lang]} />
              <GridRow>
                <FormLabel label={labels.FromDate[lang]} required />
                <FormValue component={<DateInput name="fromDate" required />} />
                <FormLabel label={labels.ToDate[lang]} required />
                <FormValue component={<DateInput name="toDate" required />} />
              </GridRow>
              <GridRow>
                <FormLabel label={labels.Zone[lang]} required />
                <FormValue
                  component={
                    <SelectInput name="zoneKey" options={zoneList} required />
                  }
                />
                <FormLabel label={labels.Counter[lang]} required />
                <FormValue
                  component={
                    <SelectInput
                      name="counterName"
                      options={counterLists}
                      required
                    />
                  }
                />
              </GridRow>

              <GridRow>
                <FormLabel label={labels.PaymentMode[lang]} required />
                <FormValue
                  component={
                    <SelectInput
                      name="modeOfPayment"
                      options={modeOfPaymentList}
                      required
                    />
                  }
                />
              </GridRow>

              <Grid container justifyContent="center" alignItems="center">
                <Grid
                  item
                  md={3}
                  container
                  justifyContent={{ md: "flex-end" }}
                  alignItems="center"
                  p={2}
                >
                  <FormButtons
                    isValid={!(formik.isValid && formik.dirty)}
                    handleSubmitButtonClick={handleSubmit}
                    resetForm={() => {
                      formik.resetForm();
                      setBillReceiptData({
                        potkirdResponseVOlst: [],
                      });
                    }}
                    submitBtnLabel="Show"
                    isSubmitIcon={false}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Form>
        </FormikProvider>
      </Grid>

      {billReceiptData.potkirdResponseVOlst.length > 0 ? (
        <>
          <Box display="flex" justifyContent="space-between">
            <div></div>
            <div className="counter-div">
              <Button
                onClick={handlePrint}
                variant="contained"
                startIcon={<Print />}
              >
                Print
              </Button>
            </div>
          </Box>
          <Grid ref={printRef}>
            <Grid container justifyContent="center">
              <Grid
                sx={{
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              >
                <b>
                  पिंपरी चिंचवड महानगरपालिका,पिंपरी - ४११०१८
                  <br />
                  लेखा विभाग
                  <br />
                  पोटकीर्द बिल पावती
                </b>
              </Grid>
            </Grid>

            <Grid
              container
              spacing={2}
              sx={{ width: "85%", marginLeft: "110px" }}
            >
              <Grid item xs={12} sm={6} md={6}>
                <div>
                  {labels.Zone[lang]} : {zone.label}
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={6}>
                <div>
                  {labels.Counter[lang]} : {formik.values.counterName}
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={6}>
                <div>
                  पासून - {formik.values.fromDate} ते {formik.values.toDate}
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={6}>
                <div>
                  {labels.PaymentMode[lang]} : {selectdeModeOfPayment.name}
                </div>
              </Grid>
            </Grid>
            <br />
            <Divider />
            <Grid>
              <GridRow>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    // alignItems: "center",
                    // p: 2,
                  }}
                >
                  <TextField
                    label="Search Property/Receipt Number"
                    variant="outlined"
                    value={searchTerm}
                    onChange={handleSearchChange}
                    size="small"
                  />
                  <>Total rows : {filteredRows.length}</>

                  {/* <TablePagination
                component="div"
                count={filteredRows.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[5, 10, 25, 50, 100]}
              /> */}
                </Box>
                <TableContainer>
                  <Table
                    size="small"
                    sx={{ minWidth: 550 }}
                    aria-label="simple table"
                    style={{ width: "100%" }} // Ensure the table takes full width
                  >
                    <TableHead>
                      <TableRow
                        sx={{
                          background: "#e6eaeb",
                          "&:last-child td, &:last-child th": {
                            border: "1px solid black",
                          },
                        }}
                      >
                        <TableCell align="center" sx={tableCellCss}>
                          {labels.SrNoShort[lang]}
                        </TableCell>
                        {/* <TableCell align="center">{labels.Zone[lang]}</TableCell>
                    <TableCell align="center">{labels.Gat[lang]}</TableCell> */}
                        <TableCell align="center" sx={tableCellCss}>
                          {labels.PropertyNumber[lang]}
                        </TableCell>
                        <TableCell align="center" sx={tableCellCss}>
                          {labels.PropertyName[lang]}
                        </TableCell>
                        <TableCell align="center" sx={tableCellCss}>
                          {labels.PaymentMode[lang]}
                        </TableCell>
                        <TableCell align="center" sx={tableCellCss}>
                          {labels.ReceiptDate[lang]}
                        </TableCell>
                        <TableCell align="center" sx={tableCellCss}>
                          {labels.ZoneReceiptNumber[lang]}
                        </TableCell>
                        <TableCell align="center" sx={tableCellCss}>
                          {labels.ReceiptNumber[lang]}
                        </TableCell>
                        <TableCell align="center" sx={tableCellCss}>
                          {labels.Fagil[lang]}
                        </TableCell>
                        <TableCell align="center" sx={tableCellCss}>
                          {labels.ManagmentTax[lang]}
                        </TableCell>
                        <TableCell align="center" sx={tableCellCss}>
                          {labels.GeneralTax[lang]}
                        </TableCell>
                        <TableCell align="center" sx={tableCellCss}>
                          {labels.TreeTax[lang]}
                        </TableCell>
                        <TableCell align="center" sx={tableCellCss}>
                          {labels.SewerageTax[lang]}
                        </TableCell>
                        <TableCell align="center" sx={tableCellCss}>
                          {labels.WaterTax[lang]}
                        </TableCell>
                        <TableCell align="center" sx={tableCellCss}>
                          {labels.RoadTax[lang]}
                        </TableCell>
                        <TableCell align="center" sx={tableCellCss}>
                          {labels.VisheshSafSafaiKar[lang]}
                        </TableCell>
                        <TableCell align="center" sx={tableCellCss}>
                          {labels.EducationTax[lang]}
                        </TableCell>
                        <TableCell align="center" sx={tableCellCss}>
                          {labels.RojgarKar[lang]}
                        </TableCell>
                        <TableCell align="center" sx={tableCellCss}>
                          {labels.FlorageTax[lang]}
                        </TableCell>
                        <TableCell align="center" sx={tableCellCss}>
                          {labels.FlorageTaxNoticeFee[lang]}
                        </TableCell>
                        <TableCell align="center" sx={tableCellCss}>
                          {labels.RojgarNoticeFee[lang]}
                        </TableCell>
                        <TableCell align="center" sx={tableCellCss}>
                          {labels.ManapaKar[lang]}
                        </TableCell>
                        <TableCell align="center" sx={tableCellCss}>
                          {labels.EducationTaxNoticeFee[lang]}
                        </TableCell>
                        <TableCell align="center" sx={tableCellCss}>
                          {labels.FagilVasuli[lang]}
                        </TableCell>
                        <TableCell align="center" sx={tableCellCss}>
                          {labels.IllegalBaandhkamShhasti[lang]}
                        </TableCell>
                        <TableCell align="center" sx={tableCellCss}>
                          {labels.Other[lang]}
                        </TableCell>
                        <TableCell align="center" sx={tableCellCss}>
                          {labels.PreviousTotal[lang]}
                        </TableCell>
                        <TableCell align="center" sx={tableCellCss}>
                          {labels.CurrentTotal[lang]}
                        </TableCell>
                        <TableCell align="center" sx={tableCellCss}>
                          {labels.Total[lang]}
                        </TableCell>
                        <TableCell align="center" sx={tableCellCss}>
                          {labels.Action[lang]}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredRows
                        // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((item, index) => {
                          return (
                            <TableRow key={index}>
                              <TableCell
                                align="center"
                                className="cellBorder"
                                sx={tableCellCss}
                              >
                                {index + 1}
                              </TableCell>
                              {/* <TableCell align="center" className="cellBorder">
                            {item.zoneName}
                          </TableCell>
                          <TableCell align="center" className="cellBorder">
                            {item.gatName}
                          </TableCell> */}
                              <TableCell
                                align="center"
                                className="cellBorder"
                                sx={tableCellCss}
                              >
                                {item.propertyCode}
                              </TableCell>
                              <TableCell
                                align="center"
                                className="cellBorder"
                                sx={tableCellCss}
                              >
                                {item.propertyName}
                              </TableCell>
                              <TableCell
                                align="center"
                                className="cellBorder"
                                sx={tableCellCss}
                              >
                                {item.modeofpayment}
                              </TableCell>
                              <TableCell
                                align="center"
                                className="cellBorder"
                                sx={tableCellCss}
                              >
                                {item.receiptDate}
                              </TableCell>
                              <TableCell
                                align="center"
                                className="cellBorder"
                                sx={tableCellCss}
                              >
                                {item.zonalreceipt}
                              </TableCell>
                              <TableCell
                                align="center"
                                className="cellBorder"
                                sx={tableCellCss}
                              >
                                {item.receiptNo}
                              </TableCell>
                              <TableCell
                                align="center"
                                className="cellBorder"
                                sx={tableCellCss}
                              >
                                {item.fajilAmount}
                              </TableCell>
                              <TableCell
                                align="center"
                                className="cellBorder"
                                sx={tableCellCss}
                              >
                                {item.tax14}
                              </TableCell>
                              <TableCell
                                align="center"
                                className="cellBorder"
                                sx={tableCellCss}
                              >
                                {item.tax1}
                              </TableCell>
                              <TableCell
                                align="center"
                                className="cellBorder"
                                sx={tableCellCss}
                              >
                                {item.tax8}
                              </TableCell>
                              <TableCell
                                align="center"
                                className="cellBorder"
                                sx={tableCellCss}
                              >
                                {item.tax21}
                              </TableCell>
                              <TableCell
                                align="center"
                                className="cellBorder"
                                sx={tableCellCss}
                              >
                                {item.tax36}
                              </TableCell>
                              <TableCell
                                align="center"
                                className="cellBorder"
                                sx={tableCellCss}
                              >
                                {item.tax38}
                              </TableCell>
                              <TableCell
                                align="center"
                                className="cellBorder"
                                sx={tableCellCss}
                              >
                                {item.tax7}
                              </TableCell>
                              <TableCell
                                align="center"
                                className="cellBorder"
                                sx={tableCellCss}
                              >
                                {item.tax6}
                              </TableCell>
                              <TableCell
                                align="center"
                                className="cellBorder"
                                sx={tableCellCss}
                              >
                                {item.tax10}
                              </TableCell>
                              <TableCell
                                align="center"
                                className="cellBorder"
                                sx={tableCellCss}
                              >
                                {item.tax5}
                              </TableCell>
                              <TableCell
                                align="center"
                                className="cellBorder"
                                sx={tableCellCss}
                              >
                                {item.tax29}
                              </TableCell>
                              <TableCell
                                align="center"
                                className="cellBorder"
                                sx={tableCellCss}
                              >
                                {item.tax23}
                              </TableCell>
                              <TableCell
                                align="center"
                                className="cellBorder"
                                sx={tableCellCss}
                              >
                                {item.tax28}
                              </TableCell>
                              <TableCell
                                align="center"
                                className="cellBorder"
                                sx={tableCellCss}
                              >
                                {item.tax24}
                              </TableCell>
                              <TableCell
                                align="center"
                                className="cellBorder"
                                sx={tableCellCss}
                              >
                                {item.tax25}
                              </TableCell>
                              <TableCell
                                align="center"
                                className="cellBorder"
                                sx={tableCellCss}
                              >
                                {item.taxCommon3945}
                              </TableCell>
                              <TableCell
                                align="center"
                                className="cellBorder"
                                sx={tableCellCss}
                              >
                                {item.tax37}
                              </TableCell>
                              <TableCell
                                align="center"
                                className="cellBorder"
                                sx={tableCellCss}
                              >
                                {item.arrears}
                              </TableCell>
                              <TableCell
                                align="center"
                                className="cellBorder"
                                sx={tableCellCss}
                              >
                                {item.current}
                              </TableCell>
                              <TableCell
                                align="center"
                                className="cellBorder"
                                sx={tableCellCss}
                              >
                                {item.total}
                              </TableCell>
                              <TableCell
                                align="center"
                                className="cellBorder"
                                sx={tableCellCss}
                              >
                                {item.receiptreturn}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </GridRow>
            </Grid>
            <Divider sx={{ marginTop: "30px", marginBottom: "30px" }} />
            <Grid>
              <GridRow>
                <TableContainer>
                  <Box sx={{ textAlign: "center" }}>
                    दिनांक {formik.values.fromDate || "DD/MM/YYYY"} पासून{" "}
                    {formik.values.toDate || "DD/MM/YYYY"} रोजीचा भरणा तपशील{" "}
                  </Box>
                  <Table
                    size="small"
                    sx={{ minWidth: 550 }}
                    aria-label="simple table"
                  >
                    <TableHead>
                      <TableRow
                        sx={{
                          background: "#e6eaeb",
                          "&:last-child td, &:last-child th": {
                            border: "1px solid black",
                          },
                        }}
                      >
                        <TableCell align="center" rowSpan={2}>
                          {labels.SrNoShort[lang]}
                        </TableCell>
                        <TableCell align="center" rowSpan={2}>
                          {labels.Details[lang]}
                        </TableCell>
                        <TableCell align="center" colSpan={2}>
                          {labels.Rokh[lang]}
                        </TableCell>
                        <TableCell align="center" colSpan={2}>
                          {labels.Bank[lang]}
                        </TableCell>
                        <TableCell align="center" colSpan={2}>
                          {labels.Total[lang]}
                        </TableCell>
                      </TableRow>
                      <TableRow
                        sx={{
                          background: "#e6eaeb",
                          "&:last-child td, &:last-child th": {},
                        }}
                      >
                        <TableCell align="center">
                          {labels.sankhya[lang]}
                        </TableCell>
                        <TableCell align="center">
                          {labels.RakkamRupaye[lang]}
                        </TableCell>
                        <TableCell align="center">
                          {labels.sankhya[lang]}
                        </TableCell>
                        <TableCell align="center">
                          {labels.RakkamRupaye[lang]}
                        </TableCell>
                        <TableCell align="center">
                          {labels.sankhya[lang]}
                        </TableCell>
                        <TableCell align="center">
                          {labels.RakkamRupaye[lang]}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    {billReceiptData ? (
                      <TableBody>
                        <TableRow>
                          <TableCell align="center" className="cellBorder">
                            1
                          </TableCell>
                          <TableCell align="center" className="cellBorder">
                            {labels.ActiveReceipt[lang]}
                          </TableCell>
                          <TableCell align="center" className="cellBorder">
                            {billReceiptData.activeCashCount}
                          </TableCell>
                          <TableCell align="center" className="cellBorder">
                            {billReceiptData.activeCashAmount}
                          </TableCell>
                          <TableCell align="center" className="cellBorder">
                            {billReceiptData.activeBankCount}
                          </TableCell>
                          <TableCell align="center" className="cellBorder">
                            {billReceiptData.activeBankAmount}
                          </TableCell>
                          <TableCell align="center" className="cellBorder">
                            {billReceiptData.totalCashBankCount}
                          </TableCell>
                          <TableCell align="center" className="cellBorder">
                            {billReceiptData.totalCashBankAmnt}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell align="center" className="cellBorder">
                            2
                          </TableCell>
                          <TableCell align="center" className="cellBorder">
                            {labels.CancelReceipt[lang]}
                          </TableCell>
                          <TableCell align="center" className="cellBorder">
                            {billReceiptData.cancelCashCount}
                          </TableCell>
                          <TableCell align="center" className="cellBorder">
                            {billReceiptData.cancelCashAmount}
                          </TableCell>
                          <TableCell align="center" className="cellBorder">
                            {billReceiptData.cancelBankCount}
                          </TableCell>
                          <TableCell align="center" className="cellBorder">
                            {billReceiptData.cancelBankAmount}
                          </TableCell>
                          <TableCell align="center" className="cellBorder">
                            {billReceiptData.cancelCashBankCount}
                          </TableCell>
                          <TableCell align="center" className="cellBorder">
                            {billReceiptData.cancelCashBankAmount}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            align="center"
                            className="cellBorder"
                          ></TableCell>
                          <TableCell align="center" className="cellBorder">
                            {labels.Total[lang]}
                          </TableCell>
                          <TableCell align="center" className="cellBorder">
                            {billReceiptData.totalCashCount}
                          </TableCell>
                          <TableCell align="center" className="cellBorder">
                            {billReceiptData.totalCashAmount}
                          </TableCell>
                          <TableCell align="center" className="cellBorder">
                            {billReceiptData.totalBankCount}
                          </TableCell>
                          <TableCell align="center" className="cellBorder">
                            {billReceiptData.totalBankAmount}
                          </TableCell>
                          <TableCell align="center" className="cellBorder">
                            {billReceiptData.totalTotalCount}
                          </TableCell>
                          <TableCell align="center" className="cellBorder">
                            {billReceiptData.totalTotalAmount}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    ) : (
                      ""
                    )}
                  </Table>
                </TableContainer>
              </GridRow>
            </Grid>
          </Grid>
        </>
      ) : (
        <></>
      )}
      <ScrollTop />
    </DashBoardContainer>
  );
};

export default PotkirdReportForBillReceipt;
